import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";
import { Button, Card, Form, Col } from "react-bootstrap";
import FileInput from "../system/FileInput";
import { parse } from "../../libs/textParser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TaglessDataAdder from "./TaglessDataAdder";

export default function CSVAppender() {
  const { addToast } = useToasts();
  const NO_OF_COLUMNS = 5;
  const DELIMITERS = ["~~", "###", ","];
  const LINEBREAKS = ["~;", "~~;", "\\n"];
  var delimiter = DELIMITERS[0];
  var linebreak = LINEBREAKS[0];
  const [data, setData] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [failedIndices, setFailedIndices] = useState(null);

  function handleContentRead(content) {
    const parsedContent = parse(content, delimiter, linebreak);
    refreshData(parsedContent);
  }

  function refreshData(content) {
    let valid = true;
    if (content && content.length) {
      const wrong = content.find((cls) => {
        cls[1] = new Date(`${cls[1]} ${cls[2]}`);
        return cls.length !== NO_OF_COLUMNS;
      });
      valid = !wrong || !wrong.length;
    } else {
      valid = false;
    }
    if (valid) {
      setData(content);
    } else {
      addToast("Invalid file format and/or content", { appearance: "error" });
    }
  }

  function DisplayForm() {
    var completed = 0;
    var faileds = [];
    function onComplete(index, success) {
      completed++;
      if (!success) {
        faileds.push(index);
      }
      if (completed === data.length) {
        if (faileds.length) {
          //setData(null);
          console.log("FAILEDS: ", faileds);
          setFailedIndices(faileds.sort());
        } else {
          setData(null);
          setProcessing(false);
        }
      }
    }

    function addTrainingData() {
      return data.map((entry, ndx) => {
        return (
          <TaglessDataAdder
            key={`da_${ndx}`}
            entry={entry}
            index={ndx}
            onComplete={(ndx, success) => {
              onComplete(ndx, success);
            }}
          />
        );
      });
    }

    function retryFaileds() {
      const retry = [];
      failedIndices.sort().forEach((i) => {
        retry.push(data[i]);
      });
      setData(retry);
      setFailedIndices(null);
    }

    if (data) {
      if (processing) {
        if (failedIndices && failedIndices.length) {
          return (
            <div>
              <Button
                className="mr-1 mb-1"
                onClick={() => {
                  retryFaileds();
                }}
              >
                Click to retry adding {failedIndices.length} failed items
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setData(null);
                  setFailedIndices(null);
                }}
              >
                Ignore errors
              </Button>
            </div>
          );
        } else {
          return addTrainingData();
        }
      } else {
        return (
          <Card>
            <Card.Body>
              <Card.Title>CSV Parsed</Card.Title>
              <Button
                className="mr-1 mb-1"
                onClick={() => {
                  setProcessing(true);
                }}
              >
                Click to add {data.length} item(s) to training data
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setData(null);
                }}
              >
                Cancel
              </Button>
            </Card.Body>
          </Card>
        );
      }
    } else {
      return (
        <Form>
          <Form.Row>
            <Form.Group
              as={Col}
              className="mb-2"
              controlId="form.delimiterselect"
            >
              <Form.Label>Field delimiter:</Form.Label>
              <select
                className="form-control"
                onChange={(e) => {
                  delimiter = e.target.value;
                }}
              >
                {DELIMITERS.map(function (d) {
                  return (
                    <option key={`del_${d}`} value={d}>
                      {d}
                    </option>
                  );
                })}
              </select>
            </Form.Group>
            <Form.Group as={Col} className="mb-2" controlId="form.lbselect">
              <Form.Label>Line break:</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => {
                  linebreak = e.target.value;
                }}
              >
                {LINEBREAKS.map(function (lb) {
                  return (
                    <option key={`lb_${lb}`} value={lb}>
                      {lb}
                    </option>
                  );
                })}
              </Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>csv file to parse:</Form.Label>
              <FileInput
                title={"Select file"}
                onContentRead={(content) => handleContentRead(content)}
              />
            </Form.Group>
          </Form.Row>
        </Form>
      );
    }
  }
  return (
    <div className="card mb-4 ">
      <div className="card-header">
        <FontAwesomeIcon icon="keyboard" className="mr-1" />
        Upload Training Data
      </div>
      <div className="card-body">
        <div className="pt-2">
          <div>
            You can upload a .csv file containing training data.
            <br />
            Make sure:
            <ul>
              <li>
                that the csv file contains the input in {NO_OF_COLUMNS} columns:
                <ul>
                  <li>source (e.g. 'DJN', 'twitter', 'web', etc)</li>
                  <li>content date (format: 'YYYY-MM-DD')</li>
                  <li>content time (format: 'HH:MM:SS')</li>
                  <li>content title</li>
                  <li>the actual content text</li>
                </ul>
              </li>
              <li>
                that the csv file does not include an additional row for the
                column titles.
              </li>
              <li>
                that the csv file does not include an additional empty line at
                the end.
              </li>
            </ul>
            <br />
          </div>

          <div>
            <DisplayForm key="dform" />
          </div>
        </div>
      </div>
    </div>
  );
}
